document.addEventListener("DOMContentLoaded", function () {

  /*==============================
    Swiper
  ==============================*/

  if (document.querySelector(".loginExclusiveSlider")) {

    // Mobile tap state tracking
    let isPausedByTap = false;

    const exclusiveSwiper = new Swiper(".loginExclusiveSlider", {

      slidesPerView: 3,
      spaceBetween: 25,
      speed: 900,
      loop: true,
      grabCursor: true,

      autoplay: {
        delay: 6500, // 6.5 Seconds
        disableOnInteraction: false,
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      breakpoints: {

        0: {
          slidesPerView: 1,
          spaceBetween: 15
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 25
        }

      },

      on: {
        init: function () {
          // Mobile check
          if (window.innerWidth < 768) {
            this.autoplay.start();
          } else {
            this.autoplay.stop();
          }
        },
        resize: function () {
          if (window.innerWidth < 768) {
            if (!isPausedByTap) {
              this.autoplay.start();
            }
          } else {
            this.autoplay.stop();
          }
        },
        // Touch / Tap event specifically for Mobile
        touchEnd: function (swiper, e) {
          if (window.innerWidth < 768) {
            
            // USP buttons tap check
            if (e && e.target && e.target.closest(".usp-btn")) {
              return;
            }

            // Agar pehle se autoplay chal rahi hai to STOP kar do
            if (swiper.autoplay.running) {
              swiper.autoplay.stop();
              isPausedByTap = true;
            } 
            // Agar paused hai to Resume kar do
            else if (isPausedByTap) {
              swiper.autoplay.start();
              isPausedByTap = false;
            }
          }
        }
      }

    });

  }

  /*==============================
    USP Image Switch
  ==============================*/

  document.querySelectorAll(".exclusive-card").forEach((card) => {

    const buttons = card.querySelectorAll(".usp-btn");

    const mainImage = card.querySelector(".exclusive-main-image");

    const hover1 = card.querySelector(".hover-image-1");

    const hover2 = card.querySelector(".hover-image-2");

    const hover3 = card.querySelector(".hover-image-3");

    function resetImages() {

      if (mainImage) mainImage.style.opacity = "1";

      if (hover1) hover1.style.opacity = "0";

      if (hover2) hover2.style.opacity = "0";

      if (hover3) hover3.style.opacity = "0";

    }

    buttons.forEach((btn) => {

      function changeImage() {

        buttons.forEach((b) => b.classList.remove("active"));

        btn.classList.add("active");

        resetImages();

        if (btn.dataset.image === "1" && hover1) {

          mainImage.style.opacity = "0";

          hover1.style.opacity = "1";

        }

        if (btn.dataset.image === "2" && hover2) {

          mainImage.style.opacity = "0";

          hover2.style.opacity = "1";

        }

        if (btn.dataset.image === "3" && hover3) {

          mainImage.style.opacity = "0";

          hover3.style.opacity = "1";

        }

      }

      btn.addEventListener("mouseenter", changeImage);

      btn.addEventListener("click", changeImage);

    });

  });

});